import { MagnifyingGlass, WhatsappLogo, EnvelopeSimple, UsersThree, Truck } from "@phosphor-icons/react";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { SITE } from "@/data/site";

const STEPS = [
  { Icon: MagnifyingGlass, title: "Browse & Select", text: <>Explore our curated collection of 2026 Specialized and Trek models.</> },
  { Icon: WhatsappLogo, title: "Contact Us", text: <>Reach out via <strong className="text-foreground">WhatsApp</strong> (+44 7806 925473) or <strong className="text-foreground">Email</strong> (sales@ebikesandgear.co.uk) with your chosen model and any questions about sizing or specs.</> },
  { Icon: UsersThree, title: "Expert Consultation", text: <>Our specialists, James or Harrison, will confirm availability, discuss custom configurations, and provide a secure payment link.</> },
  { Icon: Truck, title: "Fast EU Delivery", text: <>Once confirmed, your bike is professionally packed and shipped anywhere in Europe with full tracking.</> },
];

export default function HowToOrder() {
  return (
    <section className="container-px py-16 lg:py-24" data-testid="how-to-order-section">
      <Reveal className="max-w-2xl">
        <p className="overline">Ordering made simple</p>
        <h2 className="mt-2 text-3xl sm:text-4xl font-black tracking-tight">How to Order Your Premium E-Bike</h2>
        <p className="mt-3 text-muted-foreground leading-relaxed">Buying a world-class e-bike requires personalized attention. We've made our ordering process as seamless as your ride.</p>
      </Reveal>

      <Stagger className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map(({ Icon, title, text }, i) => (
          <StaggerItem key={title}>
            <div className="h-full rounded-3xl border border-border bg-card p-6" data-testid={`order-step-${i + 1}`}>
              <div className="flex items-center justify-between">
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-primary/10 text-primary"><Icon size={24} weight="bold" /></span>
                <span className="font-heading text-4xl font-black text-primary/25">0{i + 1}</span>
              </div>
              <h3 className="mt-4 text-lg font-bold">{title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{text}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>

      <Reveal className="mt-10">
        <div className="flex flex-wrap items-center gap-6 rounded-[2rem] bg-primary p-8 sm:p-10 text-primary-foreground sm:justify-between" data-testid="ready-to-ride-banner">
          <div>
            <h3 className="text-2xl sm:text-3xl font-black tracking-tight">Ready to ride?</h3>
            <p className="mt-1 text-sm text-primary-foreground/85">Message us now — James and Harrison typically reply within minutes.</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a href={SITE.whatsappHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold text-primary shadow-soft transition-transform hover:-translate-y-0.5" data-testid="order-whatsapp-btn">
              <WhatsappLogo size={18} weight="fill" /> Message on WhatsApp
            </a>
            <a href={`mailto:${SITE.email}`} className="inline-flex items-center gap-2 rounded-full border-2 border-white/90 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-white hover:text-primary" data-testid="order-email-btn">
              <EnvelopeSimple size={18} weight="bold" /> Send an Email
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
